import axios from "axios";

const colegioService = {
    obtenerColegiosRegionales: async () : Promise<any> =>
    {
        try
        {
           return axios.get(process.env.REACT_APP_API_URL + '/api/ColegiosRegionales/getobtenerColegiosRegionales');
        }
        catch (error: any) {
               throw error.response ? error.response.data : error.message;
            }
    }
};

export default colegioService 